module.exports = __webpack_public_path__ + "assets/img/instagram.391a2dc9.png";